import { Button } from "../../../../../../../components/button.jsx";
import React, { useState } from "react";
import { useInternet } from "../../../../../../../hooks/useInternet.js";
import { useNotify } from "../../../../../../../hooks/useNotify.js";

export function StepAccountSync({ bank, setBank, pagination }) {
  let { id, name, logo } = bank.account;

  let [result, setResult] = useState(null);

  let internet = useInternet();
  let notify = useNotify();
  let resync = async () => {
    return internet
      .post("/bank_accounts/" + id + "/sync")
      .then(async (res) => {
        let transactions = await res.json();

        pagination.reset();
        setResult(transactions);
      })
      .catch((err) => {
        notify({
          message: "Unable to sync data, please reconnect your account",
          type: "danger",
        });
        setBank({ ...bank, step: "list" });
      });
  };

  return (
    <div className={"flex flex-col gap-3"}>
      <div className={"font-medium"}>Synchronize account: {name}</div>
      {result ? (
        <>
          <p>
            Account synchronized: <strong>{result.length}</strong> transactions
            saved
          </p>
        </>
      ) : (
        <>
          <p>
            Click on the button below to synchronize the last 180 days of your
            bank account data
          </p>
          <Button onClick={resync}>resync</Button>
        </>
      )}
    </div>
  );
}
